/* Los correos de la mañana de Satelital, con un botón cada uno (ticket #456).
 *
 * Lautaro Díaz (Satelital), 19/10/2026: «PASAR SATELITALES A CAR-TRUCK […]
 * PEDIDO DE CUSTODIAS […] POSICIONES A LOS CLIENTES […] ver forma de generar
 * el correo con un botón. De todos modos esto quiero primero que lo armes a
 * prueba e ir viéndolo, mi idea es no tener que tocar tantos botones, que sea
 * entendible no sólo para mí sino para mis compañeros del sector».
 *
 * ── LOS TRES CORREOS ────────────────────────────────────────────────────────
 *
 * Lo que contestó el 20/10 a las preguntas del 19 (hilo «PLAN TORRECILLAS»):
 *
 *   · CUSTODIA: «Mando por aseguradora, todo lo de assistcargo y todo lo de
 *     arm. Pero arm sólo les paso los de r.victoria y assistcargo les paso:
 *     carrier, fapesa, solnik y bgh». Las salidas de Río Grande del día, en el
 *     formato de su SALIDAS Y CUST (sus ejemplos «SALIDAS DE RGD» y «SALIDAS
 *     TCC RGD»), un correo por aseguradora;
 *   · CAR-TRUCK: «Nono maria no hace falta, sólo operaciones. Igual, el
 *     seguimiento satelital se pasa de bue a rgd y dsp de rgd a bue». El
 *     texto es el del ejemplo de Gustavo Lynch («SEGUIMIENTO SATELITAL DE BUE
 *     A RGD/USH AL LUNES 19/10/2026»), con los tractores que tienen
 *     Car-Truck;
 *   · POSICIONES: «se pasan a carrier, solnik, fapesa y electrofueguina, se
 *     les pasa la posición actual y la fecha aprox de arribo». El formato es
 *     el de los tres de Gustavo («ARRIBOS Y SALIDAS DE SOLNIK DEL LUNES
 *     19-10-2026»): ARRIBOS y SALIDAS de ese cliente, sacados de sus
 *     planillas (ARRIBOS Y CORTES y ONLY BITRENES).
 *
 * ── CUSTODIA: LOS ASUNTOS, Y FAPESA DOS VECES ───────────────────────────────
 *
 * Lautaro, 02/11/2026, por correo: los asuntos de la custodia son los suyos,
 * tal cual: «PEDIDO DE CUSTODIAS MOVILES RVF AL LUNES 02/11/2026» el de ARM y
 * «PEDIDO DE CUSTODIA MOVILES DE ASSISTCARGO / GLOBAL AL LUNES 22/09/2026» el
 * de Assistcargo (uno dice CUSTODIAS y el otro CUSTODIA: así los escribe él).
 * Y un tercero, sólo con las de FAPESA: «Los de fapesa los pasamos tanto en
 * el correo a assistcargo como en el correo de fapesa solo. Se informan dos
 * veces, uno al cliente y aseguradora, y otro solo a la aseguradora pero con
 * las otras cargas que gerencie assistcargo: carrier, bgh o solnik». FAPESA
 * sigue en el de Assistcargo y además tiene el suyo, con la misma tabla. Su
 * asunto, en `ASUNTOS_CUSTODIA`: «PEDIDO DE CUSTODIAS MÓVILES DE FAPESA TV
 * AL ...» (Lautaro, 02/11).
 *
 * ── CAR-TRUCK DE RGD: LA 2DA PARTE VA A GALLEGOS ────────────────────────────
 *
 * Lautaro, 03/11/2026, por correo: «AHÍ ESTABA PROBANDO EL SEGUIMIENTO
 * SATELITAL DE RGD A BUE, Y CUANDO APAREZCAN LOS BITRENES, EN DESTINO LOS QUE
 * LLEVAN LA 2DA PARTE PONELES: "2DA PARTE A GALLEGOS"». El que lleva la 2da
 * parte la cruza sólo hasta Gallegos, donde la engancha el titular: no va a
 * Buenos Aires. Cuál es la 2da parte lo dice SALIDAS Y CUST (`armarSalidas`:
 * la fila con `parte.cual === 2`, el semi impar de la pareja), lo mismo que le
 * propone «A GALLEGOS» de custodia y lo que va a ARRIBOS BITREN y a Enganches.
 * La 1ra parte, la del titular, sigue con el destino de su cliente.
 *
 * «¿El Excel adjunto hace falta?» — «ellos abren el excel y lo copian y pegan
 * o si cuando yo armo el correo ellos pueden copiar y pegar desde el cuerpo
 * mejor»: va la tabla en el cuerpo, sin adjunto.
 *
 * ── LO MANDA ÉL, DESDE SU CORREO ────────────────────────────────────────────
 *
 * Como «Generar correo» de Enganches (FlotaBot `enganches_correo`) y la Orden
 * de gas oil: de acá no sale ningún mail. «Abrir en mi correo» abre uno nuevo
 * con el Para, la copia y el asunto, y «Copiar el correo» copia el cuerpo con
 * la tabla para pegarlo. Nunca dice «Cepi».
 *
 * ── A PRUEBA ────────────────────────────────────────────────────────────────
 *
 * Mientras un correo no esté marcado «real», «Abrir en mi correo» lo arma
 * para el que lo genera y nadie más, con «PRUEBA» en el asunto, y el cuerpo
 * empieza diciendo a quién iría. Así lo compara con el que manda a mano. El
 * paso a real lo hace él, correo por correo.
 *
 * Todo acá es puro: lo prueban los tests con datos inventados.
 */

import { pelado } from "./torrecillas";

/* ── Quién recibe cada uno ─────────────────────────────────────────────────── */

export const ASEGURADORAS = {
  ASSISTCARGO: ["CARRIER", "FAPESA", "SOLNIK", "BGH"],
  ARM: ["R.VICTORIA"],
};

/* El cliente como lo escriben (en la Torrecilla, en sus planillas) → su clave.
   Se reconoce por cómo EMPIEZA: «FAPESA TV LOGINTER» es FAPESA, «SOLNICK
   CENSER» es SOLNIK, «ELECTRO» y «ELECTROFUEG (LOG.CENTR» son ELECTROFUEGUINA. */
const CLIENTES = [
  ["CARRIER", ["CARRIER"]],
  ["FAPESA", ["FAPESA"]],
  ["SOLNIK", ["SOLNIK", "SOLNICK"]],
  ["BGH", ["BGH"]],
  ["R.VICTORIA", ["RVICTORIA", "RADIOVICTORIA"]],
  ["ELECTROFUEGUINA", ["ELECTRO"]],
  ["VINISA", ["VINISA"]],
  ["TECNOMYL", ["TECNOMYL"]],
];

export function clienteDe(v) {
  const p = pelado(v);
  if (!p) return "";
  for (const [clave, prefijos] of CLIENTES) {
    if (prefijos.some((x) => p.startsWith(x))) return clave;
  }
  return "";
}

export const aseguradoraDe = (cliente) =>
  Object.keys(ASEGURADORAS).find((a) => ASEGURADORAS[a].includes(clienteDe(cliente))) || "";

export const CLIENTES_POSICIONES = ["CARRIER", "SOLNIK", "FAPESA", "ELECTROFUEGUINA"];

const NOMBRE_CLIENTE = {
  CARRIER: "CARRIER", SOLNIK: "SOLNIK", FAPESA: "FAPESA TV", ELECTROFUEGUINA: "ELECTROFUEGUINA",
};

/* Los correos que hay, en el orden de la pantalla. `clave` es la fila de sus
   destinatarios (`satelital_correos`). */
export const CORREOS = [
  { clave: "cartruck:BUE", tipo: "cartruck", sentido: "BUE", nombre: "Car-Truck · salidas de Buenos Aires" },
  { clave: "cartruck:RGD", tipo: "cartruck", sentido: "RGD", nombre: "Car-Truck · salidas de Río Grande" },
  { clave: "custodia:ASSISTCARGO", tipo: "custodia", aseguradora: "ASSISTCARGO", nombre: "Custodia · Assistcargo" },
  // Las de FAPESA solas, además de en el de Assistcargo (Lautaro, 02/11).
  { clave: "custodia:FAPESA", tipo: "custodia", aseguradora: "ASSISTCARGO", cliente: "FAPESA", nombre: "Custodia · Fapesa" },
  { clave: "custodia:ARM", tipo: "custodia", aseguradora: "ARM", nombre: "Custodia · ARM" },
  ...CLIENTES_POSICIONES.map((c) => ({
    clave: `posiciones:${c}`, tipo: "posiciones", cliente: c, nombre: `Posiciones · ${NOMBRE_CLIENTE[c]}`,
  })),
];

/* ── Fechas ────────────────────────────────────────────────────────────────── */

const DIAS = ["DOMINGO", "LUNES", "MARTES", "MIERCOLES", "JUEVES", "VIERNES", "SABADO"];

function partes(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ""));
  if (!m) return null;
  const [, a, mes, d] = m;
  const dia = DIAS[new Date(Date.UTC(+a, +mes - 1, +d)).getUTCDay()];
  return { a, mes, d, dia };
}

/* «2026-10-19» → «LUNES 19/10/2026». */
export function diaLargo(iso, sep = "/") {
  const p = partes(iso);
  return p ? `${p.dia} ${p.d}${sep}${p.mes}${sep}${p.a}` : "";
}

/* ── Tablas ────────────────────────────────────────────────────────────────── */

const txt = (v) => String(v ?? "").replace(/\s+/g, " ").trim();

const esc = (s) =>
  String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]);

const TD = "border:1px solid #999;padding:4px;font-size:12px;font-family:Calibri,Arial,sans-serif;text-align:center";
const TH = `${TD};font-weight:bold;background:#f2f2f2`;

/* Una tabla `{titulo?, columnas, filas}` → HTML con bordes finos, como sus
   correos, y texto con « | » entre celdas para el que pega sin formato. */
/* `amarillas[i]` pinta de amarillo el renglón i: el que ingresa hoy (Lautaro,
   28/10, como en los correos de Gustavo). */
export const AMARILLO = "#ffff00";

export function tablaHtml({ titulo, columnas, filas, amarillas = [] }) {
  const cab = `<tr>${columnas.map((c) => `<th style="${TH}">${esc(c)}</th>`).join("")}</tr>`;
  const cuerpo = filas
    .map((f, i) => {
      const td = amarillas[i] ? `${TD};background:${AMARILLO}` : TD;
      return `<tr>${f.map((v) => `<td style="${td}">${esc(v)}</td>`).join("")}</tr>`;
    })
    .join("");
  const t = titulo ? `<p style="font-weight:bold;margin:12px 0 4px">${esc(titulo)}</p>` : "";
  return `${t}<table style="border-collapse:collapse">${cab}${cuerpo}</table>`;
}

export function tablaTexto({ titulo, columnas, filas }) {
  const r = (f) => f.map(txt).join(" | ");
  return [titulo, r(columnas), ...filas.map(r)].filter(Boolean).join("\n");
}

function armarCorreo({ asunto, parrafos, tablas, cierre }) {
  const html = [
    ...parrafos.map((p) => `<p style="margin:0 0 8px">${esc(p)}</p>`),
    ...tablas.map(tablaHtml),
    ...cierre.map((p) => `<p style="margin:12px 0 0">${esc(p)}</p>`),
  ].join("");
  const texto = [...parrafos, "", ...tablas.map(tablaTexto).flatMap((t) => [t, ""]), ...cierre].join("\n");
  return { asunto, html, texto, filas: tablas.reduce((n, t) => n + t.filas.length, 0) };
}

/* ── Custodia: las salidas de Río Grande, por aseguradora ──────────────────── */

export const COLUMNAS_CUSTODIA = [
  "Dia de Carga", "Hora de Salida", "Satelital", "Patente Tractor", "Int de Tractor", "Int de Semi",
  "Patente de Semi", "Marca", "Apellido y Nombre Chofer", "DNI", "Telefono", "Lugar de Carga",
  "Caracteristicas del viaje",
];

const fechaCorta = (iso) => {
  const p = partes(iso);
  return p ? `${p.d}/${p.mes}/${p.a}` : "";
};

/* El asunto de cada correo de custodia va seguido del día («LUNES
   02/11/2026»). Son los de Lautaro (02/11), tal cual, con su tilde el de
   FAPESA. La clave es el
   cliente del correo si es de uno solo, y si no la aseguradora. */
export const ASUNTOS_CUSTODIA = {
  ASSISTCARGO: "PEDIDO DE CUSTODIA MOVILES DE ASSISTCARGO / GLOBAL AL",
  FAPESA: "PEDIDO DE CUSTODIAS MÓVILES DE FAPESA TV AL",
  ARM: "PEDIDO DE CUSTODIAS MOVILES RVF AL",
};

/* Las filas de SALIDAS Y CUST (`armarSalidas`) de los clientes de esa
   aseguradora; con `cliente`, sólo las de ése (el correo de FAPESA). */
export function filasCustodia(bloques, aseguradora, cliente = "") {
  const out = [];
  for (const b of bloques || []) {
    for (const f of b.filas || []) {
      if (aseguradoraDe(f.lugar) !== aseguradora) continue;
      if (cliente && clienteDe(f.lugar) !== cliente) continue;
      out.push({ ...f, empresa: b.empresa });
    }
  }
  return out;
}

export function correoCustodia({ aseguradora, cliente = "", bloques, fecha, hora = "18:00HS" }) {
  const filas = filasCustodia(bloques, aseguradora, cliente);
  const clientes = [...new Set(filas.map((f) => clienteDe(f.lugar)).filter(Boolean))];
  const dia = diaLargo(fecha);
  const asunto = ASUNTOS_CUSTODIA[cliente || aseguradora] || `PEDIDO DE CUSTODIA ${cliente || aseguradora} AL`;
  return armarCorreo({
    asunto: `${asunto} ${dia}`,
    parrafos: [
      "Buenos días,",
      `Les pasamos las salidas de Río Grande del ${dia} con destino a Buenos Aires${
        clientes.length ? `, con carga de ${clientes.join(" / ")}` : ""}.`,
    ],
    tablas: [{
      columnas: COLUMNAS_CUSTODIA,
      filas: filas.map((f) => [
        fechaCorta(fecha), hora, f.satelital, f.patTractor, f.tractor, f.semi, f.patSemi, f.marca,
        f.chofer, f.dni, f.tel, f.lugar, f.caract,
      ]),
    }],
    cierre: ["Por favor confirmar la recepción del correo. Gracias.", "Saludos."],
  });
}

/* ── Car-Truck: el seguimiento satelital, en los dos sentidos ──────────────── */

export const CAR_TRUCK = "CAR-TRUCK";

/* Lautaro, 28/10 (ticket 546): «quiero que también se le agregue esta info
   tal cual […] las horas de inicio según el origen, las rutas, y el destino
   según el cliente: Y TAMBIÉN EL NÚMERO DE LAS RUTAS». Las columnas, en su
   orden. */
export const COLUMNAS_CARTRUCK = [
  "Dominio Tractor", "Interno Tractor", "Semi Interno", "Dominio semi", "Marca y tipo semi",
  "Chofer", "DNI", "Celular del chofer", "Cliente", "Fecha Servicio", "Hora Inicio", "Origen",
  "Destino", "Ruta",
];

/* Su ejemplo del 28/10 (Libro1), cliente por cliente: la ruta 1 es BUE → RGD,
   sale a las 06:00 de la base y del depósito del cliente; la ruta 2 es
   RGD → BUE, sale a las 18:00 y va al depósito del cliente en Buenos Aires.
   Un cliente que no está, con lo de la ruta y el cliente como viene. */
export const RUTAS = {
  BUE: { ruta: 1, hora: "06:00HS", destino: "RGD" },
  RGD: { ruta: 2, hora: "18:00HS", origen: "RGD" },
};
const POR_CLIENTE = {
  FAPESA: { nombre: ["FAPESA TV LOGINTER", "FAPESA TV"], origen: "BASE CANTARINI / LOGINTER", destino: "BUE ( LOGINTER PILAR )" },
  CARRIER: { nombre: ["CARRIER LOPRIMO", "CARRIER"], origen: "BASE CANTARINI / LOPRIMO", destino: "BUE ( ECHEVERRIA )" },
  SOLNIK: { nombre: ["SOLNIK", "SOLNIK"], origen: "BASE CANTARINI / CENSER", destino: "BUE ( ANDREANI )" },
  BGH: { nombre: ["BGH", "BGH"], origen: "BASE CANTARINI / DEFIBE", destino: "BUE ( SPEGAZZINI )" },
  ELECTROFUEGUINA: { nombre: ["ELECTROFUEGUINA", "ELECTROFUEGUINA"], origen: "BASE CANTARINI / M.CENTRAL", destino: "BUE ( ECHEVERRIA )" },
  "R.VICTORIA": { nombre: ["R.VICTORIA", "R.VICTORIA"], origen: "BASE CANTARINI / M.CENTRAL", destino: "BUE ( ECHEVERRIA )" },
  VINISA: { nombre: ["VINISA", "VINISA"], origen: "BASE CANTARINI", destino: "BUE ( PILAR )" },
  TECNOMYL: { nombre: ["TECNOMYL", "TECNOMYL"], origen: "BASE CANTARINI", destino: "BUE ( OLIVA CORDOBA )" },
};

/* Cliente · Fecha Servicio · Hora Inicio · Origen · Destino · Ruta. */
export function datosDeRuta(cliente, sentido, fecha) {
  const r = RUTAS[sentido] || RUTAS.BUE;
  const c = POR_CLIENTE[clienteDe(cliente)];
  const i = sentido === "RGD" ? 1 : 0;
  return [
    c ? c.nombre[i] : txt(cliente).toUpperCase(),
    fechaCorta(fecha),
    r.hora,
    sentido === "RGD" ? r.origen : (c?.origen || "BASE CANTARINI"),
    sentido === "RGD" ? (c?.destino || "BUE") : r.destino,
    r.ruta,
  ];
}

const SATELITALES = { "30717246086": CAR_TRUCK, "30525514885": "MICHELIN" };
const satelitalDelPadron = (t) => SATELITALES[String(t?.satelital ?? "")] || "";

const marcaYTipo = (furgon, marca) =>
  [txt(marca || furgon?.marca), txt(furgon?.tipo_acoplado)].filter(Boolean).join(" ").toUpperCase();

/* El chofer de un tractor: por el padrón de chofer_tractor y personas
   (`{ porInterno: {interno: dni}, porDni: {dni: {dni, telefono}} }`). */
export function choferDe(interno, choferes, nombre = "") {
  const dni = choferes?.porInterno?.[txt(interno)];
  let p = dni ? choferes?.porDni?.[String(dni)] : null;
  if (!p && nombre) {
    // Sin el tractor, por el nombre: «GOMEZ JOSE» es el que tiene ese apellido
    // y ese primer nombre, y sólo si hay uno.
    const [ap, nom] = pelado(nombre) ? txt(nombre).toUpperCase().split(" ") : [];
    const cand = (choferes?.personas || []).filter((x) => pelado(x.apellido).startsWith(pelado(ap))
      && pelado(x.apellido) && (!nom || pelado(x.nombres).startsWith(pelado(nom))));
    if (cand.length === 1) [p] = cand;
  }
  return { dni: txt(p?.dni || dni || ""), tel: txt(p?.telefono || "") };
}

/* El DESTINO del que lleva la 2da parte de un bitren hacia Gallegos
   (Lautaro, 03/11), tal cual lo escribió. */
export const DESTINO_2DA_PARTE = "2DA PARTE A GALLEGOS";
// Dónde está Destino dentro de lo que devuelve `datosDeRuta` (de Cliente a Ruta).
const DESTINO = COLUMNAS_CARTRUCK.indexOf("Destino") - COLUMNAS_CARTRUCK.indexOf("Cliente");

/* RGD → BUE: las filas de las Torrecillas con satelital Car-Truck. La 2da
   parte de un bitren (`parte.cual === 2`, de `armarSalidas`) va a Gallegos. */
export function filasCarTruckRGD(bloques, { furgones = {} } = {}, fecha = "") {
  const out = [];
  for (const b of bloques || []) {
    for (const f of b.filas || []) {
      if (f.satelital === CAR_TRUCK) {
        const ruta = datosDeRuta(f.lugar, "RGD", fecha);
        if (f.parte?.cual === 2) ruta[DESTINO] = DESTINO_2DA_PARTE;
        out.push([
          txt(f.patTractor), txt(f.tractor), txt(f.semi), txt(f.patSemi),
          marcaYTipo(furgones[txt(f.semi)], f.marca), txt(f.chofer), txt(f.dni), txt(f.tel),
          ...ruta,
        ]);
      }
    }
  }
  return out;
}

/* BUE → RGD: las salidas del día de la Previsión o del Excel de Gula
   (`/api/satelital/salidas-bitren`: bitrenes y comunes) cuyo tractor tiene
   Car-Truck en el padrón. Un bitren va en un renglón con sus dos semis. */
export function filasCarTruckBUE(salidas, { tractores = {}, furgones = {}, choferes = null } = {}, fecha = "") {
  const out = [];
  const tractor = (t) => tractores[txt(t)] || null;
  const fur = (s) => furgones[txt(s)] || null;
  const patSemi = (s) => txt(fur(s)?.dominio || fur(s)?.patente || "");
  const agregar = (int, semis, chofer, cliente) => {
    const t = tractor(int);
    if (!t || satelitalDelPadron(t) !== CAR_TRUCK) return;
    const ch = choferDe(int, choferes, chofer);
    out.push([
      txt(t.dominio), txt(int), semis.filter(Boolean).join(" / "),
      semis.map(patSemi).filter(Boolean).join(" / "),
      [...new Set(semis.filter(Boolean).map((x) => marcaYTipo(fur(x))).filter(Boolean))].join(" / "),
      txt(chofer), ch.dni, ch.tel, ...datosDeRuta(cliente, "BUE", fecha),
    ]);
  };
  for (const b of salidas?.bitrenes || []) agregar(b.tractor, [b.primera, b.segunda], b.chofer, b.cliente);
  for (const c of salidas?.comunes || []) agregar(c.tractor, [c.furgon ?? c.fr ?? c.acoplado], c.chofer, c.cliente);
  return out;
}

/* De dónde salen las salidas de BUE del correo (Lautaro, 27/10, ticket 536:
   «las cargas de Gula que yo le tiro»). Si en esta pantalla soltó el Excel de
   Gula en «Salidas de Buenos Aires», va ése, que llega antes que la Previsión
   que Tráfico carga a mano; si no, la Previsión, como siempre. El Excel se lee
   para el día elegido allá abajo: si no es el «Día de carga» del correo, no se
   mezcla un día con otro y va la Previsión, diciéndolo. `gula` es
   `{ fecha, archivo, bitrenes, comunes }` o null. */
export function fuenteCarTruckBUE(gula, dia) {
  if (!gula) return { delExcel: false, nota: "Desde la Previsión de Tráfico." };
  if (gula.fecha === dia) {
    return { delExcel: true, nota: `Desde el Excel de Gula${gula.archivo ? ` (${gula.archivo})` : ""}.` };
  }
  return {
    delExcel: false,
    nota: `Desde la Previsión de Tráfico: el Excel de Gula que soltaste es del ${diaLargo(gula.fecha)}, no del ${diaLargo(dia)}.`,
  };
}

const DESTINOS = { BUE: "BAHIA / R.GALLEGOS / RIO GRANDE / USHUAIA", RGD: "BUENOS AIRES" };
const ORIGENES = { BUE: "BUENOS AIRES", RGD: "RIO GRANDE" };

export function correoCarTruck({ sentido, filas, fecha }) {
  const clientes = [...new Set(filas.map((f) => clienteDe(f[8]) || txt(f[8]).toUpperCase()).filter(Boolean))];
  const titulo = sentido === "BUE" ? "DE BUE A RGD/USH" : "DE RGD A BUE";
  return armarCorreo({
    asunto: `SEGUIMIENTO SATELITAL ${titulo} AL ${diaLargo(fecha)}`,
    parrafos: [
      "Sres.",
      "Buenos días, solicito el seguimiento satelital de las siguientes unidades.",
      `Salen de ${ORIGENES[sentido]} con destino a ${DESTINOS[sentido]}.`,
      "Corroborar el correcto funcionamiento de los equipos satelitales y todos sus sensores, confirmar.",
      ...(clientes.length ? [`Con los siguientes clientes: ${clientes.join(" /// ")}`] : []),
    ],
    tablas: [{ columnas: COLUMNAS_CARTRUCK, filas }],
    cierre: ["Por favor informar la recepción del correo enviado. Gracias.", "Saludos."],
  });
}

/* ── Posiciones: ARRIBOS y SALIDAS de un cliente, de sus planillas ─────────── */

/* Las columnas que van, como las pidió Lautaro el 28/10 (ticket 546):

     ARRIBOS DE SOLNIK AL MIERCOLES 28/10/2026
     D/C ORIG FUR PAT TRA CHOFER CUSTODIA LUG/DIA POR LA MAÑANA F/ARRIBO
     SALIDAS DE SOLNIK AL MIERCOLES 28/10/2026
     D/C ORIG FUR PAT TRA CHOFER CUSTODIA POR LA MAÑANA F/ARRIBO

   y cómo puede estar escrito cada título en sus hojas. Se lee por el título,
   no por la posición. POR LA MAÑANA es la UBICACIÓN de las 08:00, que queda
   fija todo el día («la ubicación tiene que ser la que vos ponés a la
   mañana»), no la actualizada; en SALIDAS de ARRIBOS Y CORTES, que no tiene
   UBICACIÓN, es la columna del día («MIERCOLES 28»). */
const COLUMNAS_POSICION = [
  ["D/C", ["DC", "FC"]],
  ["ORIG", ["ORIG", "DEST", "ORIGEN", "DESTINO"]],
  ["FUR", ["FUR", "FR", "BITREN", "FURGON"]],
  ["PAT", ["PATENTES", "PATFUR", "PATENTE", "PAT"]],
  ["TRA", ["TRA", "TR", "TRAC", "TRACTOR"]],
  ["CHOFER", ["CHOFER", "CHOFERES"]],
  ["CLIENTE", ["CLIENTE", "CLIENTES", "CLIENTESLUGARDECARGA", "CLIENTELUGARDECARGA"]],
  ["CUSTODIA", ["CUSTODIA", "CUSTODIAS"]],
  ["LUG/DIA", ["LUGDIA"]],
  ["POR LA MAÑANA", ["UBICACION", "PORLAMANANA", "POSICION", "DIADEHOY"]],
  ["F/ARRIBO", ["FARRIBO", "DIASDEARRIBOSA", "DIASDEARRIBO", "ARRIBO", "FA"]],
];
const SIN_EN = { SALIDAS: ["LUG/DIA"] };
/* CLIENTE se usa para filtrar y no va en la tabla (no está en su formato). */
const NO_VAN = ["CLIENTE"];

/* La fila de títulos de una hoja (en las primeras seis) y dónde está cada
   columna. Hace falta CLIENTE y el furgón: sin eso no hay qué filtrar. */
export function encabezadoPosiciones(hoja, fecha = "") {
  const celdas = hoja?.celdas || [];
  const hoyCol = diaDeHoy(fecha);
  for (let i = 0; i < Math.min(celdas.length, 6); i++) {
    const cols = {};
    (celdas[i] || []).forEach((v, j) => {
      const p = hoyCol && pelado(v) === hoyCol ? "DIADEHOY" : pelado(v);
      for (const [nombre, alias] of COLUMNAS_POSICION) {
        // La primera columna que coincide gana: en ARRIBOS hay UBICACION y
        // UBICACION ACTUALIZADA, y va la actualizada (está primero en la lista
        // de alias, pero la hoja la tiene a la derecha).
        const k = alias.indexOf(p);
        if (k < 0) continue;
        if (cols[nombre] === undefined || k < cols[nombre].k) cols[nombre] = { j, k };
      }
    });
    if (cols.CLIENTE && cols.FUR) {
      const usar = Object.fromEntries(Object.entries(cols).map(([n, v]) => [n, v.j]));
      return { fila: i, cols: usar };
    }
  }
  return null;
}

/* «MIERCOLES28»: el título pelado de la columna del día en SALIDAS. */
function diaDeHoy(fecha) {
  const p = partes(fecha);
  return p ? `${p.dia}${+p.d}` : "";
}

/* La fecha de arribo de un renglón es hoy: «28», «28/10», «MIERCOLES 28». */
export function llegaHoy(v, fecha) {
  const p = partes(fecha);
  const t = pelado(v);
  if (!p || !t) return false;
  const d = String(+p.d);
  const m = /(\d{1,2})(?:\D*(\d{1,2}))?/.exec(String(v));
  if (!m) return false;
  if (+m[1] !== +d) return false;
  if (m[2] && +m[2] !== +p.mes) return false;
  return true;
}

/* ARRIBOS o SALIDAS, por el nombre de la hoja; CORTES y el resto no van. */
export function queHoja(nombre) {
  const p = pelado(nombre);
  if (p.includes("ARRIBO")) return "ARRIBOS";
  if (p.includes("SALIDA")) return "SALIDAS";
  return "";
}

/* El valor de una celda tapada por una combinada es el de su ancla (los dos
   renglones de un bitren combinados en TRA, CHOFER, CLIENTE…). */
function conCombinadas(hoja) {
  const celdas = (hoja?.celdas || []).map((r) => [...(r || [])]);
  for (const t of hoja?.combinadas || []) {
    const m = /^([A-Z]+)(\d+):([A-Z]+)(\d+)$/.exec(String(t).toUpperCase());
    if (!m) continue;
    const col = (l) => [...l].reduce((n, ch) => n * 26 + ch.charCodeAt(0) - 64, 0) - 1;
    const [c0, r0, c1, r1] = [col(m[1]), +m[2] - 1, col(m[3]), +m[4] - 1];
    const v = celdas[r0]?.[c0];
    for (let r = r0; r <= r1; r++) {
      for (let c = c0; c <= c1; c++) {
        if (r === r0 && c === c0) continue;
        celdas[r] = celdas[r] || [];
        celdas[r][c] = v;
      }
    }
  }
  return celdas;
}

/* Las tablas ARRIBOS y SALIDAS de un cliente, con los renglones de todas sus
   planillas (`[{nombre, datos}]`). */
export function tablasPosiciones(planillas, cliente, fecha = "") {
  const por = {
    ARRIBOS: { columnas: null, filas: [], amarillas: [] },
    SALIDAS: { columnas: null, filas: [], amarillas: [] },
  };
  for (const pl of planillas || []) {
    for (const hoja of pl?.datos?.hojas || []) {
      const cual = queHoja(hoja.nombre);
      const enc = cual && encabezadoPosiciones(hoja, fecha);
      if (!enc) continue;
      const nombres = COLUMNAS_POSICION.map(([n]) => n).filter((n) => enc.cols[n] !== undefined);
      const destino = por[cual];
      destino.columnas = destino.columnas || COLUMNAS_POSICION.map(([n]) => n)
        .filter((n) => !NO_VAN.includes(n) && !(SIN_EN[cual] || []).includes(n));
      const celdas = conCombinadas(hoja);
      celdas.forEach((r, i) => {
        if (i <= enc.fila || !r) return;
        if (clienteDe(r[enc.cols.CLIENTE]) !== cliente) return;
        if (!txt(r[enc.cols.FUR])) return;
        const fila = destino.columnas.map((n) => (nombres.includes(n) ? txt(r[enc.cols[n]]) : ""));
        const arribo = nombres.includes("F/ARRIBO") ? r[enc.cols["F/ARRIBO"]] : "";
        destino.filas.push(fila);
        destino.amarillas.push(llegaHoy(arribo, fecha));
      });
    }
  }
  // Las columnas que nadie tiene no se muestran.
  const out = [];
  for (const cual of ["ARRIBOS", "SALIDAS"]) {
    const t = por[cual];
    if (!t.filas.length) continue;
    const usadas = t.columnas.map((_, j) => t.filas.some((f) => f[j]));
    out.push({
      titulo: `${cual} DE ${NOMBRE_CLIENTE[cliente] || cliente}${fecha ? ` AL ${diaLargo(fecha)}` : ""}`,
      columnas: t.columnas.filter((_, j) => usadas[j]),
      filas: t.filas.map((f) => f.filter((_, j) => usadas[j])),
      amarillas: t.amarillas,
    });
  }
  return out;
}

export function correoPosiciones({ cliente, planillas, fecha }) {
  const tablas = tablasPosiciones(planillas, cliente, fecha);
  return armarCorreo({
    asunto: `ARRIBOS Y SALIDAS DE ${NOMBRE_CLIENTE[cliente] || cliente} DEL ${diaLargo(fecha, "-")}`,
    parrafos: [
      "Buenos días,",
      "Les pasamos la posición de las unidades por la mañana y la fecha aproximada de arribo.",
      ...(tablas.some((t) => (t.amarillas || []).some(Boolean))
        ? ["En amarillo, las que ingresan hoy."] : []),
    ],
    tablas,
    cierre: ["Saludos."],
  });
}

/* ── A prueba o real ───────────────────────────────────────────────────────── */

const UNA = /^[^@\s,;<>"']+@[^@\s,;<>"']+\.[A-Za-z]{2,}$/;

/* «a@b.com, c@d.com; e@f.com» → las direcciones válidas, sin repetir. */
export function direcciones(v) {
  const lista = Array.isArray(v) ? v : String(v ?? "").split(/[\s,;]+/);
  const out = [];
  for (const d of lista.map((x) => String(x).trim().toLowerCase())) {
    if (UNA.test(d) && !out.includes(d)) out.push(d);
  }
  return out;
}

export const PRUEBA = "PRUEBA";

/* Lo que se manda: a prueba, sólo al que lo genera, con «PRUEBA» en el asunto
   y a quién iría arriba del cuerpo; real, a sus destinatarios. `dest` es la
   fila de `satelital_correos` ({para, cc, real}). */
export function paraMandar(correo, dest, yo) {
  const para = direcciones(dest?.para);
  const cc = direcciones(dest?.cc);
  if (dest?.real) return { ...correo, para, copia: cc, prueba: false };
  const aQuien = [
    `${PRUEBA}: este correo te llega sólo a vos. De verdad iría a:`,
    `Para: ${para.join(", ") || "(sin destinatarios)"}`,
    `CC: ${cc.join(", ") || "-"}`,
  ];
  const aviso = `<p style="margin:0 0 12px;padding:6px;border:1px dashed #999">${aQuien.map(esc).join("<br>")}</p>`;
  return {
    ...correo,
    asunto: `${PRUEBA} · ${correo.asunto}`,
    html: aviso + correo.html,
    texto: `${aQuien.join("\n")}\n\n${correo.texto}`,
    para: direcciones([yo]),
    copia: [],
    prueba: true,
  };
}
